module.exports = __webpack_public_path__ + "a795c62ffb2fa9b1cca637e295d9b890.png";